// Filename: public/Hevrati.js 
//
// Code written in public files is shared by your site's
// Backend, page code, and site code environments.
//
// Use public files to hold utility functions that can 
// be called from multiple locations in your site's code.

/* export function add(param1, param2) {
	return param1 + param2;
}
*/

// The following code demonstrates how to call the add
// function from your site's page code or site code.

/* 
import {add} from 'public/Hevrati.js'

$w.onReady(function () {	
    let sum = add(6,7);
    console.log(sum);
});
*/

//The following code demonstrates how to call the add 
//function in one of your site's backend files.

/* 
import {add} from 'public/Hevrati.js'

export function usingFunctionFromPublic(a, b) {
	return add(a,b);
}
*/


import wixLocation from 'wix-location';
import {fetch} from 'wix-fetch';
import wixWindow from 'wix-window';
import {session} from 'wix-storage';
import {ReportLead} from 'backend/hevrati';


export function SessionStart() {
    var query = wixLocation.query;
    
    if (!session.getItem("utm")){
        var utm=''
        if (typeof query.utm_campaign !== 'undefined') {
            utm = query.utm_campaign;
        }
        session.setItem("utm", utm);
    }

    if (!session.getItem("referrer")){
        var referrer = String(wixWindow.referrer);
        if (referrer === null || referrer === 'null') {
            referrer = '';
        }
        session.setItem("referrer", referrer);
    }

    if (!session.getItem("videoPlayed")){
        session.setItem("videoPlayed", 0);
    }

    if (!session.getItem("sessionTime")){
        session.setItem("sessionTime", Math.round(Number(Date.now()) / 1000));
    }
}


export function NewLead(name, phone, navigateTo) {
    //Set correct path parameter
    var path = wixLocation.path[0]
    if (!path){
        path = "home"
    }
    
    //Send Salesforce + EmailJ
    ReportLead(
        name,
        phone, 
        session.getItem("utm"), 
        wixWindow.formFactor, 
        session.getItem("referrer"), 
        session.getItem("videoPlayed"), 
        path,
        Math.round(Number(Date.now()) / 1000) - session.getItem("sessionTime")
    );
    
    //Track Event in Analytics and Facebook
    /*wixWindow.trackEvent("Lead");
    wixWindow.trackEvent("CustomEvent", {
        "eventCategory": "Submit",
        "eventAction": "Form Submit",
        "eventLabel": "Lead",
        "eventValue": ""
    } );
    */

    //Redirect
    wixLocation.to(navigateTo);
}

export function Track(eventAction, eventLabel) {
    wixWindow.trackEvent("CustomEvent", {
            "eventCategory": "Interaction",
            "eventAction": eventAction,
            "eventLabel": eventLabel,
            "eventValue": 0
    } );
}



